import { defineComponent, ref } from "vue";
import CommentItem from "./CommentItem.vue";
import Loading from "@/baseui/loading/loading.vue";
import Pagination from "@/baseui/pagination/pagination.vue";
export default defineComponent({
  name: "Comment",
  props: {
    commentInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pageInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ["changeCurrent"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var curtpage = ref(1);

    var changeCurrent = function changeCurrent(page) {
      curtpage.value = page;
      emit("changeCurrent", page);
    };

    return {
      curtpage: curtpage,
      changeCurrent: changeCurrent
    };
  },
  components: {
    CommentItem: CommentItem,
    Loading: Loading,
    Pagination: Pagination
  }
});